import React from "react"
import { css } from "@emotion/core"

const Section = props => {
  const SectionTitle = props.title ? (
    <h3
      css={css`
        text-align: center;
        padding: 30px;
        font-size: 40px;
        font-weight: 300;
        margin-bottom: 30px;
      `}
      id={props.Id}
    >
      {props.title}
    </h3>
  ) : null

  return (
    <div
      className="container"
      css={css`
        padding-top: 40px;
      `}
    >
      <div>
        {SectionTitle}
        {props.children}
      </div>
    </div>
  )
}
export default Section
